/* eslint-disable @typescript-eslint/explicit-member-accessibility */
import React, { Component } from 'react';
import { Tag } from '@firesoon/antd';
import { FSCheckableTagProps } from './interface';
import './index.less';

const { CheckableTag } = Tag;

class Index extends Component<FSCheckableTagProps> {
  static defaultProps = {
    className: ''
  };

  render() {
    const { children, className, checked, ...rest } = this.props;
    return (
      <CheckableTag
        className={`${checked ? '' : 'fs-tag-notCheck'} fs-checkableTag ${className}`}
        checked={checked}
        {...rest}
      >
        {children}
      </CheckableTag>
    );
  }
}

export default Index;
